/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `FI` - Finmid
 * * `SP` - Sprinque
 */
export type InvoiceFinanceProvider = typeof InvoiceFinanceProvider[keyof typeof InvoiceFinanceProvider];


export const InvoiceFinanceProvider = {
  FI: 'FI',
  SP: 'SP',
} as const;
